import ClientConfigServices from "../../../../../Services/ClientConfigServices";
import axios from "axios";

const addAccounts = async (inputData, vendorID, setLoader, toast, getData, resetForm, handleShowAccountsForm) => {
  try {
    setLoader(true);
    let response = await ClientConfigServices.addAccounts(vendorID, inputData);
    if (response.status === 200) {
      toast.success(response.data.message);
      setLoader(false);
      resetForm();
      handleShowAccountsForm();
      getData();
      return { success: true };
    }
    setLoader(false);
    toast.error(`Unexpected response status: ${response.status}`);
    return { success: false, error: "unexpected_status" };
  } catch (e) {
    setLoader(false);
    // Check for validation errors from backend
    if (axios.isAxiosError(e) && e.response?.status === 409) {
      const data = e.response.data;
      if (data.error_code === "exact_match") {
        toast.error(data.message || "Store name already exists");
        return { success: false, error: "exact_match" };
      }
    }
    toast.error("An error occurred while creating the store");
    return { success: false, error: "unknown" };
  }
};

const UpdateAccounts = async (inputData, VendorID, AccountsID, setLoader, toast, getData) => {
  try {
    setLoader(true);
    let response = await ClientConfigServices.editAccounts(VendorID, AccountsID, inputData);
    if (response.status === 200) {
      toast.success(response.data.message);
      setLoader(false);
      getData();
      return { success: true };
    }
    setLoader(false);
    toast.error(`Unexpected response status: ${response.status}`);
    return { success: false, error: "unexpected_status" };
  } catch (e) {
    setLoader(false);
    // Check for validation errors from backend
    if (axios.isAxiosError(e) && e.response?.status === 409) {
      const data = e.response.data;
      if (data.error_code === "exact_match") {
        toast.error(data.message || "Store name already exists");
        return { success: false, error: "exact_match" };
      }
    }
    toast.error("An error occurred while updating the store");
    return { success: false, error: "unknown" };
  }
};

export { addAccounts, UpdateAccounts };
